import { getArray } from "app/components/tables/common-table/constant";

export const BaseListProgram = getArray().map((index) => `Chương trình ${index}`)